// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import AMap from 'vue-amap';
import { lazyAMapApiLoaderInstance } from 'vue-amap';
import "quill/dist/quill.snow.css";
import "quill/dist/quill.core.css";
import '@/assets/fonts/fonts/font-awesome.min.css'
import '@/assets/css/dashboard.css'
import '@/assets/plugins/charts-c3/c3-chart.css'
import '@/assets/plugins/fullside-menu/waves.min.css'
import '@/assets/css/icons.css'
import $ from 'jquery'
import 'bootstrap/dist/js/bootstrap.bundle'
import 'toastr2/dist/toastr.min.css'
import 'selectize'
import 'jquery-sparkline'
import 'jquery-slimscroll'
import 'malihu-custom-scrollbar-plugin'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Chat from 'jwchat';
import { VueEditor, Quill } from "vue2-editor"
import {initIdentity} from '@/api/common'
import store from './store'
import {getToken} from "@/utils/auth";
import {loginTest,adminLogin} from "@/api/user";
import echarts from 'echarts'
import 'babel-polyfill'
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(AMap)
Vue.use(Chat)

AMap.initAMapApiLoader({
    key: 'ae5cff0f0837cce38a7480b0b6735d99',
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch','AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geolocation','AMap.Geocoder', 'AMap.AMapManager', 'AMap.Marker'],
    v: '1.4.4'
  });
lazyAMapApiLoaderInstance.load().then(()=>{
  localStorage.removeItem('_AMap_raster');
  Vue.use(AMap);
});
let site = localStorage.getItem('site');

function getQueryString(name){
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  if(window.location.hash.indexOf("?") < 0) return null;
  let r = window.location.hash.split("?")[1].match(reg); 　　
  if (r != null) return decodeURIComponent(r[2]); 
　　    return null; 
}
if (site == null || site==''){
  store.dispatch("app/changeSite",{id:3,appName:'淄博站'})
  Vue.prototype.$lastSite = null
  localStorage.setItem("showSiteDialog","true")
}else{
  const lastSite = JSON.parse(site)
  Vue.prototype.$lastSite = lastSite
  store.dispatch("app/changeSite",lastSite)
}
var vm
if (process.env.NODE_ENV=='development'){
  //sx_admin 123456 1 18706768812
  //sunday_1990 123123 0 18706768812
  // loginTest('sx_admin','123456',1,'18706768812').then(response => {
  var ua = navigator.userAgent.toLowerCase()
  if(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)){
    loginTest('sx_admin','123456',1,'18706768812').then(response => {
      let token = response.accessToken;
      localStorage.setItem("accessToken",token);
      if (token != null){
        console.log("登录授权Token:" + token)
        store.dispatch("user/loadAbility").then(res => {
          console.log(res)
          vm =new Vue({
            el: '#app',
            router,
            store,
            components: { App },
            template: '<App/>',
          })
        }).catch(error => {
          console.log(error)
        })
      }else{
        console.log("访客客户身份浏览,平台初始化")
        vm = new Vue({
          el: '#app',
          router,
          store,
          components: { App },
          template: '<App/>',
        })
      }
    })
  }else{
    loginTest('sx_admin','123456',1,'18706768812').then(response => {
    //  loginTest('yufengfeng','123456',0,'18706768812').then(response => {
      // loginTest('guanyu','123456',1,'18706768812').then(response => {
      // loginTest('xiantong','xiantong123',1,'18706768812').then(response => {
      // loginTest('jh2285516','jh2285516',1,'18706768812').then(response => {
      // loginTest('guanjiaqiTest','w2820354',0,'15994775314').then(response => {
      //  loginTest('suxianwei','suxianwei',0,'15994775314').then(response => {
      // loginTest('苏谋雯','123456',0,'18149318397').then(response => {
      let token = response.accessToken;
      localStorage.setItem("accessToken",token);
      if (token != null){
        console.log("登录授权Token:" + token)
        store.dispatch("user/loadAbility").then(res => {
          console.log(res)
          vm =new Vue({
            el: '#app',
            router,
            store,
            components: { App },
            template: '<App/>',
          })
        }).catch(error => {
          console.log(error)
        })
      }else{
        console.log("访客客户身份浏览,平台初始化")
        vm = new Vue({
          el: '#app',
          router,
          store,
          components: { App },
          template: '<App/>',
        })
      }
    })
  }
}else{
  let withNoLogin = getQueryString('unLogin')
  console.log(withNoLogin)
  if(withNoLogin==null || withNoLogin=='undefined' || withNoLogin==''){
    let token = getToken()
    if (token != null){
      console.log("登录授权Token:" + token)
      store.dispatch("user/loadAbility").then(res => {
        console.log(res)
        vm = new Vue({
          el: '#app',
          router,
          store,
          components: { App },
          template: '<App/>',
        })
      }).catch(error => {
        console.log(error)
      })
    }else{
      vm = new Vue({
        el: '#app',
        router,
        store,
        components: { App },
        template: '<App/>',
      })
    }
  }else{
    console.log("访客客户身份浏览,平台初始化")
    vm =new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>',
    })
  }
}
/* eslint-disable no-new */



// WEBPACK FOOTER //
// ./src/main.js